import { applyAdvancedFilterRows } from "./advancedFilter";

function textContains(haystack, keyword) {
  const q = String(keyword || "").trim().toLowerCase();
  if (!q) return true;
  const h = haystack != null ? String(haystack).toLowerCase() : "";
  return h.includes(q);
}

function idFieldMatches(row, field, value) {
  const v = String(value || "").trim();
  if (!v) return true;
  if (v === "__none__") {
    const raw = row?.[field];
    return raw == null || String(raw).trim() === "";
  }
  return String(row?.[field] || "") === v;
}

function amountTypeMatches(row, amountType) {
  const t = String(amountType || "").trim();
  if (!t || t === "all") return true;
  const amountNum = Number(row?.amount);
  if (!Number.isFinite(amountNum)) return false;
  if (t === "income") return amountNum >= 0;
  if (t === "expense") return amountNum < 0;
  return true;
}

const TRANSACTION_ADVANCED_MATCHERS = {
  nameNotes: (row, value) =>
    textContains(row?.name, value) || textContains(row?.notes, value),
  category: (row, value) => textContains(row?.category, value),
  taxCategory: (row, value) => textContains(row?.taxCategory, value),
  financialAccountId: (row, value) => idFieldMatches(row, "financialAccountId", value),
  assetId: (row, value) => idFieldMatches(row, "assetId", value),
  vendorId: (row, value) => idFieldMatches(row, "vendorId", value),
  amountType: (row, value) => amountTypeMatches(row, value),
};

/**
 * @param {object[]} transactions
 * @param {Record<string, *>} criteria
 */
export function filterTransactionsByAdvancedCriteria(transactions, criteria) {
  return applyAdvancedFilterRows(transactions, criteria, {
    matchers: TRANSACTION_ADVANCED_MATCHERS,
  });
}
